/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CouponsHalResponse } from '../../models/coupons-hal-response';

export interface CouponsCodeCodeGet$Params {
  'Active-Tenant-Identifier': string;
  code: string;
}

export function couponsCodeCodeGet(http: HttpClient, rootUrl: string, params: CouponsCodeCodeGet$Params, context?: HttpContext): Observable<StrictHttpResponse<CouponsHalResponse>> {
  const rb = new RequestBuilder(rootUrl, couponsCodeCodeGet.PATH, 'get');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.path('code', params.code, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CouponsHalResponse>;
    })
  );
}

couponsCodeCodeGet.PATH = '/coupons/code/{code}';
